import React from "react";
import FarmerImg from "../../../images/gbrCBN/CBNImg3.webp";
import UpdatesBanner from "../../UpdatesBanner/UpdatesBanner";
import TransporterImg from "../../../images/gbrCBN/CBNImg7.webp";
import HomeSubSection from "../HomeSubSection/HomeSubSection";
import CBNServices from "../../OurServices/CBNServices";
import CBNBenefits from "../Benefits/CBNBenefits";
import CBN from "../../../images/GBR Tech (CBN Network) - GBR Tech - 14-05-2024 N.gif";
import ProductionManagerImg from "../../../images/gbrPN/PNImg5.webp";
import CBNManager from "./CBNManager";
import CBNMainServices from "./CBNMainServices";
import CBNNetworkBenefit from "./CBNNetworkBenefit";
// Main component for CBN Network 

export default function CBNNetwork() {
  return (
    <>
    {/* Banner section */}
      <UpdatesBanner
        className="cbnbg text-white"
        bannerTitle="Seed to Sale"
        bannerbodycopy1={[
          <span key="1">
            CBO & Agro Dealers can BUILD, OWN, MANAGE & OPERATE CBN Network to
            help farmers and agri-retailers
          </span>,
          <br key="2" className="d-lg-block d-none" />,
          <span key="3">
            with everything they need from seed to sale
          </span>,
        ]}
        bannerbodycopy="Local Trade | Quality Inputs | Insurance | Advisory | Capital"
      />

      {/* Overview Section */}
      <div className="mt-5">
        <h4 className="container-title text-center mx-md-4">Overview</h4>
        <HomeSubSection
          fontBold="true"
          className="rowReverseAbout align-items-center"
          listItems={<CBNBenefits />}
          description="Agribusiness can Build their Own Community network (Virtual Clubs) to obtain group organic certification and find the best partners for local trade."
          src={CBN}
          grid={true}
          btn2={true}
        />
      </div>

      {/* Services Section  */}
      <CBNMainServices />
            {/* Feature Section   */}

      <CBNServices />
            {/* Benefits Section */}

      <CBNNetworkBenefit />

      {/* Beneficiaries Section */}
      <div className="subSectionWrapper">
        <h2 className="text-center container-title">
          BENEFICIARIES OF CBN NETWORK
        </h2>

        {/* Collectives */}
        <HomeSubSection
          className="rowReverseAbout borderedCards borderedCards--mod"
          description="NGOs are non-profit organizations focused on supporting agricultural development and rural communities. They offer services like education, training, and technical assistance to farmers, helping them adopt sustainable practices and access markets, ultimately promoting food security and rural development."
          description1="NGOs | SHGs | FPOs | CS"
          descriptionTitle="Collectives"
          src={TransporterImg}
          className3="ngo-img"
          href1="/collectives"
          buttoncont1="View CBN deployment for collectives"
        />

        {/* Agri-Retailer */}
        <HomeSubSection
          className="rowReverseAbout--mod borderedCards borderedCards--mod"
          className3="agri-retailer-role"
          description="Agri-retailers specialize in selling agricultural inputs such as seeds, fertilizers, and farm equipment to farmers. They also provide agronomic advice, soil testing, and crop protection solutions. They play a crucial role in the agricultural supply chain, supporting farmers in maximizing yields and profitability."
          descriptionTitle="Agri Retailer"
          src={ProductionManagerImg}
          href1="/agri-retailers"
          buttoncont1="View CBN deployment for agri-retailers"
          description1="Farm Machinery Retailers | Nutrition Retailers | Agri Input Retailers | Farmers' Advisors"
        />

        {/* Farmer */}
        <HomeSubSection
          className="rowReverseAbout borderedCards borderedCards--mod"
          description="GBR Team strongly believes that one of the ways to create IMPACT is to improve the living standards of small-scale agri-producers & generate rural employment through Agri-MSMEs."
          descriptionTitle="Farmer"
          src={FarmerImg}
          href1="/farmers"
          buttoncont1="View CBN deployment for farmers"
        />
      </div>

      {/* List of operators & managers section */}
      <div className="subSectionWrapper main-wrapper2">
        <CBNManager />
      </div>
    </>
  );
}

